import type { ReactNode } from "react"

import type {
  SolarProposalDesignDto,
  SolarProposalDesignSectionDto,
} from "~/api/dto/solar-proposal-design.dto"

import { SectionNotice } from "./SectionNotice"
import { Home, SystemSpecs } from "./sections/system"
import type {
  SolarPresentationHeader,
  SolarSectionState,
} from "./solar-presentation-data"
import { toSolarResidence, toSolarSystem } from "./solar-proposal-design"

/**
 * The aerial card and spec cards. The design read loads and fails on its own,
 * so the header and hero above it stay rendered whatever happens here. An
 * editor's page passes the design's edit entry point as `action`.
 */
export const SolarDesignSection = ({
  header,
  state,
  action,
}: {
  header: SolarPresentationHeader
  state: SolarSectionState<SolarProposalDesignSectionDto>
  action?: (design: SolarProposalDesignDto) => ReactNode
}): JSX.Element => {
  if (state.status !== `ready`) {
    return <SectionNotice id="system" state={state} noun="the system design" />
  }

  const { design } = state.data
  if (!design) {
    return <SectionNotice id="system">System design not ready yet</SectionNotice>
  }

  return (
    <>
      <Home
        residence={toSolarResidence(design, header)}
        action={action?.(design)}
      />
      <SystemSpecs system={toSolarSystem(design)} />
    </>
  )
}
